export class ListOrganizationIdpGroupsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "idpId",
            "baseName": "idpId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return ListOrganizationIdpGroupsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
